module.exports = __webpack_public_path__ + "media/src/application/media/route_3-b34504eaeeaeed3f0a6acdeea551a52b.webp";